import { useState } from 'react';
import { createPortal } from 'react-dom';

import { useLanguage } from '../LanguageContext';
import Pic1 from '../assets/images/pic1.webp';
import Pic2 from '../assets/images/pic2.webp';
import Pic3 from '../assets/images/pic3.webp';
import Pic4 from '../assets/images/pic4.webp';
import Pic5 from '../assets/images/pic5.webp';
import ProposalPic01 from '../assets/images/proposal/01_XLL_6392.webp';
import ProposalPic02 from '../assets/images/proposal/02_XLL_6672.webp';
import ProposalPic03 from '../assets/images/proposal/03_XLL_6330.webp';
import ProposalPic04 from '../assets/images/proposal/04_XLL_6285.webp';
import ProposalPic05 from '../assets/images/proposal/05_XLL_6253.webp';
import ProposalPic06 from '../assets/images/proposal/06_XLL_6278.webp';
import ProposalPic07 from '../assets/images/proposal/07_XLL_6196.webp';
import ProposalPic08 from '../assets/images/proposal/08_XLL_6123.webp';
import ProposalPic09 from '../assets/images/proposal/09_XLL_5951.webp';
import ProposalPic10 from '../assets/images/proposal/10_XLL_5912.webp';
import ProposalPic11 from '../assets/images/proposal/11_XLL_5908.webp';
import ProposalPic12 from '../assets/images/proposal/12_XLL_5893.webp';
import ProposalPic13 from '../assets/images/proposal/13_XLL_5715.webp';
import ProposalPic14 from '../assets/images/proposal/14_XLL_5720.webp';
import ProposalPic15 from '../assets/images/proposal/15_XLL_6695.webp';

const galleryImagesJeju = [
  { src: Pic1, alt: 'Gallery photo 1' },
  { src: Pic2, alt: 'Gallery photo 2' },
  { src: Pic3, alt: 'Gallery photo 3' },
  { src: Pic4, alt: 'Gallery photo 4' },
  { src: Pic5, alt: 'Gallery photo 5' },
];

const galleryImagesProposal = [
  { src: ProposalPic01, alt: 'Proposal photo 1' },
  { src: ProposalPic02, alt: 'Proposal photo 2' },
  { src: ProposalPic03, alt: 'Proposal photo 3' },
  { src: ProposalPic04, alt: 'Proposal photo 4' },
  { src: ProposalPic05, alt: 'Proposal photo 5' },
  { src: ProposalPic06, alt: 'Proposal photo 6' },
  { src: ProposalPic07, alt: 'Proposal photo 7' },
  { src: ProposalPic08, alt: 'Proposal photo 8' },
  { src: ProposalPic09, alt: 'Proposal photo 9' },
  { src: ProposalPic10, alt: 'Proposal photo 10' },
  { src: ProposalPic11, alt: 'Proposal photo 11' },
  { src: ProposalPic12, alt: 'Proposal photo 12' },
  { src: ProposalPic13, alt: 'Proposal photo 13' },
  { src: ProposalPic14, alt: 'Proposal photo 14' },
  { src: ProposalPic15, alt: 'Proposal photo 15' },
];

function GalleryModal({
  setIsZoomed,
  setActiveIndex,
  galleryImages,
  activeIndex,
}) {
  const { t } = useLanguage();

  return createPortal(
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 cursor-pointer bg-black/85"
      onClick={() => setIsZoomed(false)}
    >
      <div className="relative w-full h-full flex items-center justify-center pointer-events-none">
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            setIsZoomed(false);
          }}
          className="absolute right-4 top-4 pointer-events-auto rounded-full px-4 py-2 text-white transition font-semibold text-sm bg-offwhite-bg/25 hover:bg-offwhite-bg/45"
        >
          {t('gallery.close')}
        </button>

        <img
          src={galleryImages[activeIndex].src}
          alt={galleryImages[activeIndex].alt}
          className="max-w-[85%] max-h-[75vh] object-contain shadow-2xl rounded-2xl pointer-events-auto cursor-default"
          onClick={(event) => event.stopPropagation()}
        />

        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            setActiveIndex((prev) =>
              prev === 0 ? galleryImages.length - 1 : prev - 1,
            );
          }}
          className="absolute left-4 top-1/2 -translate-y-1/2 pointer-events-auto rounded-full w-12 h-12 flex items-center justify-center text-white text-xl transition font-bold bg-offwhite-bg/15 hover:bg-offwhite-bg/30"
        >
          &lt;
        </button>
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            setActiveIndex((prev) =>
              prev === galleryImages.length - 1 ? 0 : prev + 1,
            );
          }}
          className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-auto rounded-full w-12 h-12 flex items-center justify-center text-white text-xl transition font-bold bg-offwhite-bg/15 hover:bg-offwhite-bg/30"
        >
          &gt;
        </button>
      </div>
    </div>,
    document.body,
  );
}

function GalleryCollection({ galleryImages }) {
  const { t } = useLanguage();
  const [activeIndex, setActiveIndex] = useState(0);
  const [isZoomed, setIsZoomed] = useState(false);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  const minSwipeDistance = 50;

  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;
    if (isLeftSwipe) {
      setActiveIndex((prev) =>
        prev === galleryImages.length - 1 ? 0 : prev + 1,
      );
    } else if (isRightSwipe) {
      setActiveIndex((prev) =>
        prev === 0 ? galleryImages.length - 1 : prev - 1,
      );
    }
  };

  return (
    <div className="w-full select-none">
      {/* Active Image Box */}
      <div
        className="gallery-image-box h-80 sm:h-96 md:h-[450px]"
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
      >
        <button
          onClick={() => setIsZoomed(true)}
          className="w-full h-full focus:outline-none flex items-center justify-center cursor-zoom-in"
        >
          <img
            src={galleryImages[activeIndex].src}
            alt={galleryImages[activeIndex].alt}
            className="max-w-full max-h-full object-contain"
          />
        </button>

        {/* Left Arrow */}
        <button
          onClick={(e) => {
            e.stopPropagation();
            setActiveIndex((prev) =>
              prev === 0 ? galleryImages.length - 1 : prev - 1,
            );
          }}
          className="absolute left-4 top-1/2 -translate-y-1/2 rounded-full active:scale-95 shadow-md p-3 transition z-10 flex items-center justify-center w-10 h-10 font-bold bg-offwhite-bg/85 text-heading hover:bg-offwhite-bg"
          aria-label="Previous image"
        >
          &lt;
        </button>

        {/* Right Arrow */}
        <button
          onClick={(e) => {
            e.stopPropagation();
            setActiveIndex((prev) =>
              prev === galleryImages.length - 1 ? 0 : prev + 1,
            );
          }}
          className="absolute right-4 top-1/2 -translate-y-1/2 rounded-full active:scale-95 shadow-md p-3 transition z-10 flex items-center justify-center w-10 h-10 font-bold bg-offwhite-bg/85 text-heading hover:bg-offwhite-bg"
          aria-label="Next image"
        >
          &gt;
        </button>

        {/* Counter */}
        <div className="absolute bottom-4 right-4 px-3 py-1 rounded-full text-xs text-white z-10 font-normal bg-heading/65">
          {activeIndex + 1} / {galleryImages.length}
        </div>
      </div>

      {/* Thumbnails list below */}
      <div className="flex gap-2.5 mt-4 overflow-x-auto py-2 px-1 no-scrollbar justify-start sm:justify-center">
        {galleryImages.map((image, index) => (
          <button
            key={image.alt + '-' + index}
            onClick={() => setActiveIndex(index)}
            className={`relative flex-shrink-0 w-16 h-16 sm:w-20 sm:h-20 rounded-2xl overflow-hidden border-2 transition-all duration-300 focus:outline-none ${
              activeIndex === index
                ? 'gallery-thumb-active'
                : 'gallery-thumb-inactive'
            }`}
          >
            <img
              src={image.src}
              alt={image.alt}
              className="w-full h-full object-cover"
            />
          </button>
        ))}
      </div>

      {/* Lightbox / Zoom view */}
      {isZoomed && (
        <GalleryModal
          setIsZoomed={setIsZoomed}
          setActiveIndex={setActiveIndex}
          galleryImages={galleryImages}
          activeIndex={activeIndex}
        />
      )}
    </div>
  );
}

export default function GalleryPage() {
  const { t } = useLanguage();
  return (
    <div className="w-full min-h-screen space-y-24">
      <div className="space-y-4">
        <p className="text-2xl text-content-h1 text-center">
          {t('gallery.title_jeju')}
        </p>
        <p className="text-lg text-content-c1 text-center">
          {t('gallery.desc_jeju')}
        </p>
        <GalleryCollection galleryImages={galleryImagesJeju} />
      </div>
      <div className="space-y-4">
        <p className="text-2xl text-content-h1 text-center">
          {t('gallery.title_proposal')}
        </p>
        <p className="text-lg text-content-c1 text-left">
          {t('gallery.desc_proposal')}
        </p>
        <p className="text-base text-content-c1 text-left">
          <i>{t('gallery.fun_fact_proposal')}</i>
        </p>
        <GalleryCollection galleryImages={galleryImagesProposal} />
      </div>
    </div>
  );
}
